import { withProps, compose, withHandlers, renderNothing, branch, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import SaveForLater from './SaveForLater'
import { getActiveVehicleName } from 'selectors/getActiveVehicle'
import isAuthorized from 'helpers/check-authorization'
import { getSaveForLaterItems } from 'selectors/shoppingData'
import { googleAnalyticProductImpressions } from 'actions/googleAnalytic'
import { getGTMData } from 'helpers/googleAnalytic'
import { getFavoriteSkus } from 'components/MyFavorites/selectors'
import { hideHorizontalScroll } from 'helpers/utils'

const MAX_NUMBER_DESKTOP_ITEMS = 4
const MAX_NUMBER_TABLET_ITEMS = 3
const MAX_NUMBER_SMALL_TABLET_ITEMS = 2.2
const MAX_NUMBER_MOBILE_ITEMS = 1

const withIsVisible = withState('capSlider', 'setCapSlider', 0)
const withObserver = withState('intersectionObserver', 'setObserver', null)

const mapStateToProps = state => ({
  vehicleName: getActiveVehicleName(state),
  saveForLaterItems: getSaveForLaterItems(state),
  favoriteSkus: getFavoriteSkus(state)
})

const withSignInClick = withHandlers({
  handleLoginMenu: () => (e) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('loginFormOpen'))
    }, 10)
  },
  increaseCapSlider: ({ capSlider, setCapSlider }) => () => setCapSlider(capSlider + 1)
})

const withInitializationAndUpdating = lifecycle({
  componentDidMount() {
    const { setObserver, increaseCapSlider } = this.props
    const html = document.querySelector('html')
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    }
    const intersectionObserver = new IntersectionObserver(entries => {
      entries[0].isIntersecting && increaseCapSlider()
    }, observerOptions)

    setObserver(intersectionObserver)
    increaseCapSlider()
    hideHorizontalScroll(html)
  },
  componentDidUpdate({ capSlider: prevCapSlider }) {
    const {
      capSlider,
      intersectionObserver,
      saveForLaterItems,
      googleAnalyticProductImpressions,
      favoriteSkus
    } = this.props

    if ((prevCapSlider !== capSlider) && intersectionObserver) {
      const saveForLaterSlider = document.querySelector('.slick-list')
      saveForLaterSlider && intersectionObserver.observe(saveForLaterSlider)
    }

    if (capSlider !== 1 && (prevCapSlider !== capSlider) && intersectionObserver) {
      googleAnalyticProductImpressions({
        data: getGTMData({ saveForLaterItems, favoriteSkus })
      })
    }
  }
})

const withCarouselConfig = withProps(({ saveForLaterItems }) => {
  const itemsQuantity = !saveForLaterItems ? 0 : saveForLaterItems.length

  const baseConfig = {
    slidesToScroll: 1,
    slidesToShow: MAX_NUMBER_DESKTOP_ITEMS,
    dots: false,
    draggable: false,
    autoplay: false,
    arrows: itemsQuantity > MAX_NUMBER_DESKTOP_ITEMS,
    infinite: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          draggable: true,
          arrows: false,
          slidesToShow: MAX_NUMBER_TABLET_ITEMS,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          draggable: true,
          arrows: false,
          slidesToShow: MAX_NUMBER_SMALL_TABLET_ITEMS,
          centerMode: false
        }
      },
      {
        breakpoint: 500,
        settings: {
          draggable: true,
          arrows: false,
          slidesToShow: MAX_NUMBER_MOBILE_ITEMS,
          centerMode: true
        }
      }
    ]
  }

  return {
    carouselConfig: baseConfig,
    isAuthorized: isAuthorized()
  }
})

const withRenderNothing = branch(
  ({ saveForLaterItems }) => !saveForLaterItems || !saveForLaterItems.length,
  renderNothing
)

export default compose(
  connect(mapStateToProps, { googleAnalyticProductImpressions }),
  withIsVisible,
  withObserver,
  withCarouselConfig,
  withSignInClick,
  withRenderNothing,
  withInitializationAndUpdating
)(SaveForLater)
